module.exports = __webpack_public_path__ + "static/img/activity_sdy_03-2.aed7d84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_03-2.jpg
// module id = T1Ea
// module chunks = 0